<template>
  <div>
    <div
      class="avatarImage rounded-pill ml-autos"
      :class="{ 'atm-shadow': selectedAvatar.url }"
      @click="$bvModal.show('childAvatar')"
    >
      <img
        :src="
          selectedAvatar.url
            ? selectedAvatar.url
            : require(`@/assets/child-profile-empty.png`)
        "
        alt="child avatar"
        class="rounded-pill"
      />
      <span class="bg-light material-icons-round rounded-pill atm-shadow p-2">
        add
      </span>
    </div>
    <b-modal
      id="childAvatar"
      size="md"
      centered
      :hide-header="true"
      :hide-footer="true"
      content-class="p-2 atm-rounded"
    >
      <h3 class="mb-4">Child Avatar</h3>
      <section
        class="d-flex gap-4 flex-wrap justify-content-center align-items-center mb-4"
      >
        <div
          v-for="image in avatarBank"
          :key="image.id"
          class="imageContainer atm-rounded atm-shadow"
          :class="{ selectedImage: selectedAvatar.url === image.image }"
          @click="selectAvatar(image.image, image.id)"
        >
          <img
            :src="image.image"
            :alt="`image_${image.id}`"
          />
        </div>
      </section>
      <div class="d-flex gap-4 justify-content-center align-items-center"></div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    currentAvatar: {
      type: Object,
      default: () => { return {id: 0, url: '' }}
    },
    avatarBank: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return { 
      selectedAvatar: this.currentAvatar
    };
  },
  methods: {
    selectAvatar(avatarUrl, avatarId) {
      this.selectedAvatar = { url: avatarUrl, id: avatarId }
      
      this.$emit('selectAvatar', this.selectedAvatar.id);
      this.$bvModal.hide('childAvatar');
    },
    hideModal() {
      this.$bvModal.hide('childAvatar');
    }
  }
};
</script>

<style lang="scss">
.imageContainer {
  width: 100px;
  height: 100px;
  transition: 100ms;
  outline: 0px solid var(--color-main);
  cursor: pointer;

  &:hover {
    outline: 2px solid var(--color-main);
    transform: scale(1.05);
  }

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.selectedImage {
  outline: 2px solid var(--color-main);
}

.avatarImage {
  position: relative;
  background-color: white;
  width: 100%;
  height: 100%;
  cursor: pointer;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  & > span {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
</style>